import { autoinject, transient } from "aurelia-dependency-injection";
import { OnboardingConfigModel, OnboardingRequestRuleModel } from "../../../../../../models/onboarding/onboarding.models";
import { ChildComponent } from "../../../../modules/child-component";
import { PropertyMetaModel } from "../../../../../../models/basics/basics.models";
import { EditableFieldBinding, GridUtils } from "../../../../../components/data-grid/data-grid";
import { DataType } from "../../../../../../models/queries/queries.models";
import { BindingSignaler } from "aurelia-templating-resources";
import { NotificationClientService, NotificationType } from "../../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { OnboardingAdminService } from "../../../../../../services/onboarding/onboarding-admin.service";
import * as moment from "moment";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { useView } from "aurelia-framework";

@autoinject()
@transient()
@useView('views/pages/admin/onboarding/steps/onboarding-rules-script/onboarding-rules-script.html')
export class OnboardingRulesScript extends ChildComponent<OnboardingConfigModel>
{
    rules: OnboardingRequestRuleModel[];
    variables: PropertyMetaModel[] = [];
    testData: {
        property: PropertyMetaModel,
        value: string
    }[] = [];

    constructor(private bindingSignaler: BindingSignaler,
        private onboardingAdminService: OnboardingAdminService,
        notificationService: NotificationClientService,
        i18n: I18N, private configService: ConfigService) {
        super(notificationService, i18n);
    }

    activate(model: { item: OnboardingConfigModel, variables: PropertyMetaModel[] }) {
        if (!model.item.rulesScriptLanguage) {
            model.item.rulesScriptLanguage = "csharp";
            model.item.rulesScript =
                'using System;\n' +
                'using Genesis.Onboarding.Models.Entities;\n' +
                'using System.Collections.Generic;\n' +
                'using Genesis.Onboarding.Models.Models;\n' +
                '\n' +
                'public static List<OnboardingRequestRule> Run(OnboardingRulesRequest request)\n' +
                '{\n' +
                '    List<OnboardingRequestRule> rules = new List<OnboardingRequestRule>();\n' +
                '\n' +
                '    let meta = request.Meta;\n' +
                '    //let propertyName = "prop1";\n' +
                '    //let message = "my message";\n' +
                '    //if(meta[propertyName] == "myValue"){\n' +
                '    //  rules.Add(new OnboardingRequestRule(propertyName, message));\n' +
                '    //}\n' +
                '    //propertyName = "prop2";\n' +
                '    //message = "my message2";\n' +
                '    //if(meta[propertyName] == "myValue2"){\n' +
                '    //  rules.Add(new OnboardingRequestRule(propertyName, message));\n' +
                '    //}\n' +
                '    return rules;\n' +
                '}';
        }
        this.variables = model.variables;
        super.activate(model.item);
    }

    addTestData() {
        this.testData.push({
            property: null,
            value: null
        });
    }

    public filtersHtml(item: { property: PropertyMetaModel, value: string }): string {

        if (!item) {
            return '';
        }

        const binding: EditableFieldBinding = {
            query: "item.property.parameter",
            lookup: item && item.property ? item.property.parameter : null,
            isEditable: true,
            binding: "item.value",
            displayValueBinding: "${item.value}",
            value: item.property.parameter,
            isValueCollection: false,
            isPropertyCollection: false,
            dataType: item.property.parameter && item.property.type != DataType.HierarchicalLookup ? DataType.Lookup : item.property.type,
            parameter: "item.value",
            secondParameter: null,
            isNotRangeDatePicker: true,
            isSecondParameterBindable: false,
            startLabel: null,
            endLabel: null,
            isNullable: true
        };

        return GridUtils.getControl(binding, true);
    }

    onPropertySelected() {
        this.bindingSignaler.signal('update-filters-html');
    }

    runTest() {
        return new Promise<void>((resolve, reject) => {
            this.onboardingAdminService.runOnboardingRulesTest({
                onboardingConfigId: this.item.onboardingConfigId,
                properties: this.testData.map(x => ({
                    propertyDisplayName: x.property.displayName,
                    propertyName: x.property.camelCasePropertyName,
                    lookupName: x.property.type == DataType.Lookup || x.property.type == DataType.HierarchicalLookup ? x.property.parameter : null,
                    value: x.value
                }))
            }).then(response => {
                if (response.error) {
                    this.rules = [];
                    this.notificationService.show("Error", response.error, NotificationType.Error);
                } else {
                    this.rules = response.rules;
                }
                resolve();
            }).catch(() => {
                this.notificationService.show("Error", "Failed to run test", NotificationType.Error);
                reject();
            });
        });
    }

    getMessage(rule: OnboardingRequestRuleModel) {
        if (!rule.clientSideParameters || !rule.clientSideParameters.length) {
            return rule.message;
        }
        else {
            let i;
            for (i = 0; i < rule.clientSideParameters.length; i++) {

                const momentObj = moment.utc(rule.clientSideParameters[i]);

                if (momentObj.isValid()) {
                    return rule.message.replace("{" + i + "}", momentObj.local().format(this.configService.config.common.defaultDateFormat));
                }

                return rule.message.replace("{" + i + "}", rule.clientSideParameters[i]);
            }
        }
    }
}
